/** @format */

$(document).ready(function () {
  let substance = $("input[name='media']:checked").val();
  let ppmecValue = $("input[name='ppm_ec']:checked").val();
  let waterValue = $("input[name='water-unit']:checked").val();
  let reservoir_size = 1;
  let nutrientValue = $("input[name='nutrient']:checked").val();
  let selectedVegWeekColumn = $("#veg_weeks").val();
  let selectedFlowerWeekColumn = $("#flower_weeks").val();
  const volumeTableContainer = $("#volume_calculator");
  let requiredNutrient = {};
  let closeBtnEl = $(".close-btn");
  let cycleInput = 1;
  let unitConvertedVegArray = [];
  let unitConvertedFlowerArray = [];
  $("#reservoir_value").val(reservoir_size);

  $("#cycle-input").val(cycleInput);
  const svgIcon = $(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#d9241c" class="close-btn-icon" width="24" height="24"><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" /></svg>'
  );

  // Easy series tables
  const easySoilVeg = [
    ["GROW", 5, 8, 10, 12, 14, 14, 14, 14, 14, 14],
    ["SURGE", 4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
    [
      "Suggested PPM Range",
      "400-500",
      "600-700",
      "700-800",
      "900-1000",
      "1000-1100",
      "1000-1100",
      "1000-1100",
      "1000-1100",
      "1000-1100",
      "1000-1100",
    ],
  ];
  // const originalEasySoilVeg = deepCopyArray(easySoilVeg);
  const easySoilFlower = [
    ["BLOOM", 15, 17, 19, 19, 20, 22, 22, 22, 22, 22, 22, 22, 22, 22],
    ["SURGE", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["BUD START", "", 0.4, 0.4, "", "", "", "", "", "", "", "", "", "", ""],
    ["TON O BUD", "", "", "", 2, 2, "", "", "", "", "", "", "", "", ""],
    [
      "BUD BOOM",
      "",
      "",
      "",
      "",
      "",
      1.2,
      1.2,
      1.2,
      1.2,
      1.2,
      1.2,
      1.2,
      1.2,
      1.2,
    ],
    ["CARBO BLAST", 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [
      "Suggested PPM Range",
      "900-1000",
      "1200-1300",
      "1300-1400",
      "1300-1450",
      "1400-1500",
      "1400-1500",
      "1400-1500",
      "1400-1500",
      "1400-1500",
      "1400-1500",
      "1400-1500",
      "1400-1500",
      "1400-1500",
      "1400-1500",
    ],
  ];
  // const originalEasySoilFlower = deepCopyArray(easySoilFlower);
  // holland series table
  const hollandSoilVeg = [
    ["MICRO", 6, 8, 8, 8, 9, 10, 10, 10, 10, 10],
    ["GROW", 10, 12, 15, 17, 17, 19, 19, 19, 19, 19],
    ["BLOOM", 4, 5, 5, 5, 6, 6, 6, 6, 6, 6],
    ["SUPER B+", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["ROYAL GOLD", 7, 9, 9, 9, 9, 11, 11, 11, 11, 11],
    ["PLANTACILLIN", 2, 2, 4, 4, 4, 4, 4, 4, 4, 4],
    ["CARBO BLAST", 2, 2, 4, 4, 4, 4, 4, 4, 4, 4],
    ["PROP-O-GATOR", 7, 7, 10, 10, 10, 14, 14, 14, 14, 14],
    ["ROYAL BLACK", 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
    [
      "Suggested PPM Range",
      "300 - 500",
      "500 - 750",
      "750 - 950",
      "950 - 1050",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
    ],
  ];
  // const originalHollandSoilVeg = deepCopyArray(hollandSoilVeg);
  const hollandCocoVeg = [
    ["MICRO", 6, 8, 8, 8, 9, 10, 10, 10, 10, 10],
    ["GROW", 10, 12, 15, 17, 17, 19, 19, 19, 19, 19],
    ["BLOOM", 4, 5, 5, 5, 6, 6, 6, 6, 6, 6],
    ["CALNESIUM", 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5],
    ["SUPER B+", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["ROYAL GOLD", 7, 9, 9, 9, 9, 11, 11, 11, 11, 11, 11],
    ["PLANTACILLIN", 2, 2, 4, 4, 4, 4, 4, 4, 4, 4],
    ["CARBO BLAST", 2, 2, 4, 4, 4, 4, 4, 4, 4, 4],
    ["PROP-O-GATOR", 7, 7, 10, 10, 10, 14, 14, 14, 14, 14, 14, 14],
    ["ROYAL BLACK", 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
    [
      "Suggested PPM Range",
      "300 - 500",
      "500 - 750",
      "750 - 950",
      "950 - 1050",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
    ],
  ];
  // const originalHollandCocoVeg = deepCopyArray(hollandCocoVeg);
  const hollandHydroVeg = [
    ["MICRO", 6, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["GROW", 10, 12, 14, 14, 14, 14, 14, 14, 14, 14],
    ["BLOOM", 3, 4, 4, 4, 4, 4, 4, 4, 4, 4],
    ["CALNESIUM", 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5],
    ["SUPER B+", 6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
    ["ROYAL GOLD", 7, 9, 9, 9, 9, 11, 11, 11, 11, 11],
    ["PLANTACILLIN", 2, 2, 4, 4, 4, 4, 4, 4, 4, 4],
    ["CARBO BLAST", 2, 2, 4, 4, 4, 4, 4, 4, 4, 4],
    ["PROP-O-GATOR", 5, 5, 10, 10, 10, 11, 11, 11, 11, 11],
    [
      "Suggested PPM Range",
      "300 - 500",
      "500 - 750",
      "750 - 950",
      "950 - 1050",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
      "1050 - 1200",
    ],
  ];
  // const originalHollandHydroVeg = deepCopyArray(hollandHydroVeg);
  const hollandSoilFlower = [
    ["MICRO", 6, 7, 7, 8, 8, 7, 6, 6, 6, 6, 6, 6, 6, 6],
    ["GROW", 5, 4, 3, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1],
    ["BLOOM", 9, 11, 11, 15, 17, 19, 21, 21, 21, 21, 21, 21, 21, 21],
    ["CALNESIUM", 2.5, 2.5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
    ["SUPER B+", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["ROYAL GOLD", 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11],
    ["PLANTACILLIN", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["CARBO BLAST", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["PROP-O-GATOR", 14, 10, 7, 7, "", "", "", "", "", "", "", "", "", ""],
    ["ROYAL BLACK", 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
    ["BUD START", "", 6, 8, "", "", "", "", "", "", "", "", "", "", ""],
    ["TON O BUD", "", "", "", 8, 8, "", "", "", "", "", "", "", "", ""],
    ["BUD BOOM", "", "", "", "", "", 8, 8, 8, 8, 8, 8, 8, 8, 8],
    [
      "Suggested PPM Range",
      "850-950",
      "1000-1200",
      "1200-1350",
      "1350-1500",
      "1600-1700",
      "1500-1650",
      "1400-1500",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
    ],
  ];
  // const originalHollandSoilFlower = deepCopyArray(hollandSoilFlower);
  const hollandCocoFlower = [
    ["MICRO", 6, 7, 7, 8, 8, 7, 6, 6, 6, 6, 6, 6, 6, 6],
    ["GROW", 5, 4, 3, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1],
    ["BLOOM", 9, 11, 11, 15, 17, 19, 21, 21, 21, 21, 21, 21, 21, 21, 21],
    ["CALNESIUM", 2.5, 2.5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
    ["SUPER B+", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["ROYAL GOLD", 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11],
    ["PLANTACILLIN", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["CARBO BLAST", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["PROP-O-GATOR", 14, 10, 7, 7, "", "", "", "", "", "", "", "", "", ""],
    ["ROYAL BLACK", 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
    ["BUD START", "", 6, 8, "", "", "", "", "", "", "", "", "", "", ""],
    ["TON O BUD", "", "", "", 8, 8, "", "", "", "", "", "", "", "", ""],
    ["BUD BOOM", "", "", "", "", "", 8, 8, 8, 8, 8, 8, 8, 8, 8],
    [
      "Suggested PPM Range",
      "850-950",
      "1000-1200",
      "1200-1350",
      "1350-1500",
      "1600-1700",
      "1500-1650",
      "1400-1500",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
    ],
  ];
  // const originalHollandCocoFlower = deepCopyArray(hollandCocoFlower);
  const hollandHydroFlower = [
    ["MICRO", 6, 7, 7, 8, 8, 8, 6, 6, 6, 6, 6, 6, 6, 6],
    ["GROW", 3, 3, 3, 3, 3, 2, 1, 1, 1, 1, 1, 1, 1, 1],
    ["BLOOM", 9, 9, 9, 17, 17, 19, 21, 21, 21, 21, 21, 21, 21, 21],
    ["CALNESIUM", 2.5, 2.5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
    ["SUPER B+", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["ROYAL GOLD", 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11],
    ["PLANTACILLIN", 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
    ["CARBO BLAST", 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    ["PROP-O-GATOR", 11, 10, 5, 5, "", "", "", "", "", "", "", "", "", ""],
    ["BUD START", "", 6, 8, "", "", "", "", "", "", "", "", "", "", ""],
    ["TON O BUD", "", "", "", 8, 8, "", "", "", "", "", "", "", "", ""],
    ["BUD BOOM", "", "", "", "", "", 8, 8, 8, 8, 8, 8, 8, 8, 8],
    [
      "Suggested PPM Range",
      "850-950",
      "1000-1200",
      "1200-1350",
      "1350-1500",
      "1350-1500",
      "1350-1500",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
      "1250-1400",
    ],
  ];
  // const originalHollandHydroFlower = deepCopyArray(hollandHydroFlower);
  // dosaline series table
  const dosaSoilVeg = [
    ["BASE", 2.3, 3, 3.8, 3.8, 3.8, 3.8, 3.8, 3.8, 3.8, 3.8],
    ["GROW", 2.3, 3, 3.8, 3.8, 3.8, 3.8, 3.8, 3.8, 3.8, 3.8],
    ["HYPO", 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    ["SURGE PRO", 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    [
      "Suggested PPM Range",
      "750-1050",
      "750-1050",
      "750-1050",
      "850-1190",
      "850-1190",
      "1150-1610",
      "1150-1610",
      "1150-1610",
      "1150-1610",
      "1150-1610",
      "1150-1610",
      "1150-1610",
      "1150-1610",
      "1150-1610",
    ],
  ];
  // const originalDosaSoilVeg = deepCopyArray(dosaSoilVeg);
  const dosaSoilFlower = [
    ["BASE", 4.5, 4.5, 4.5, 5.3, 5.3, 6, 6, 6, 6, 6, 6, 6, 6, 6],
    ["BLOOM", 2.6, 2.6, 2.6, 3, 3, 3.8, 3.8, 3.8, 3.8, 3.8, 3.8, 3.8, 3.8, 3.8],
    ["HYPO", 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    ["SURGE PRO", 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
    [
      "Suggested PPM Range",
      "900-1260",
      "900-1260",
      "900-1260",
      "1000-1400",
      "1000-1400",
      "1200-1680",
      "1200-1680",
      "1200-1680",
      "1200-1680",
      "1200-1680",
      "1200-1680",
      "1200-1680",
      "1200-1680",
      "1200-1680",
    ],
  ];
  // const originaldosaSoilFlower = deepCopyArray(dosaSoilFlower);
  function vegTableHandler() {
    return nutrientValue === "easy_series"
      ? easySoilVeg
      : nutrientValue === "holland_secret"
      ? substance === "soil"
        ? hollandSoilVeg
        : substance === "coco"
        ? hollandCocoVeg
        : hollandHydroVeg
      : dosaSoilVeg;
  }

  function flowerTableHandler() {
    return nutrientValue === "easy_series"
      ? easySoilFlower
      : nutrientValue === "holland_secret"
      ? substance === "soil"
        ? hollandSoilFlower
        : substance === "coco"
        ? hollandCocoFlower
        : hollandHydroFlower
      : dosaSoilFlower;
  }
  let selectedNutrientMediaVegArray = vegTableHandler();
  let selectedNutrientMediaFlowerArray = flowerTableHandler();

  // ================================= creating and populating table ===========================
  function createTable(array, tableContainer, columnLength, tableTitle) {
    let table = $('<table cellpadding="0" cellspacing="0" border="0"></table>');
    let tableContainerEl = $(`#${tableContainer}`);
    // creating table header
    thHeader = $("<tr></tr>");
    thHeader.append($(`<th colspan="2">${setTableHeader()}</th>`));
    var rowHeader = $("<th></th>")
      .attr("colspan", columnLength)
      .text(tableTitle);
    thHeader.append(rowHeader);
    table.append(thHeader);

    // creating week row
    weekRow = $("<tr></tr>");
    weekRow.append($("<th></th>"));
    for (var j = 0; j < columnLength; j++) {
      var rowData = $("<th></th>").text("Week " + (j + 1));
      weekRow.append(rowData);
    }
    table.append(weekRow);

    // populating main content from array
    for (let i = 0; i < array.length; i++) {
      // Iterate through the rows of the array
      let row =
        array[i][0] === "MICRO" ||
        array[i][0] === "GROW" ||
        array[i][0] === "BLOOM" ||
        array[i][0] === "BASE" ||
        array[i][0] === "Suggested PPM Range"
          ? $("<tr></tr>")
          : $("<tr class='row_remove'></tr>");

      for (let j = 0; j <= columnLength; j++) {
        // Iterate through the columns of the current row
        let cell = $(
          `${
            (array[i][j] === "MICRO" ||
              array[i][j] === "GROW" ||
              array[i][j] === "BLOOM" ||
              array[i][j] === "BASE" ||
              array[i][j] === "Suggested PPM Range") &&
            j === 0
              ? "<td class='left-header' ></td>"
              : i < array.length - 1 && j === 0
              ? "<td class='close-btn left-header'></td>"
              : "<td></td>"
          }`
        );
        cell.text(
          typeof array[i][j] === "number"
            ? nutrientValue === "holland_secret"
              ? (
                  (waterValue === "gallon"
                    ? array[i][j]
                    : array[i][j] / 3.785) * reservoir_size
                ).toFixed(2) + " ml"
              : (
                  (waterValue === "gallon"
                    ? array[i][j]
                    : array[i][j] / 3.785) * reservoir_size
                ).toFixed(2) + " gm"
            : array[i][j]
            ? array[i][j]
            : 0
        );
        row.append(cell); // Append cell to the row
      }
      table.append(row); // Append row to the table
    }
    tableContainerEl.append(table);
  }

  function tableRedrawer() {
    $("table").remove();
    createTable(
      selectedNutrientMediaVegArray,
      "greenContent",
      selectedVegWeekColumn,
      "VEGETATIVE STAGE"
    );
    createTable(
      selectedNutrientMediaFlowerArray,
      "redContent",
      selectedFlowerWeekColumn,
      "FLOWERING / RIPENING STAGE"
    );
    closeBtnEl.prepend(svgIcon);
    requiredNutrient = {};
    volumeCalculator(selectedNutrientMediaVegArray, selectedVegWeekColumn);
    volumeCalculator(
      selectedNutrientMediaFlowerArray,
      selectedFlowerWeekColumn
    );
    volumeTableDrawer(cycleInput);
    rowRemoval();
    closeBtnEl = $(".close-btn");
    closeBtnEl.prepend(svgIcon);
  }

  createTable(
    selectedNutrientMediaVegArray,
    "greenContent",
    selectedVegWeekColumn,
    "VEGETATIVE STAGE"
  );
  createTable(
    selectedNutrientMediaFlowerArray,
    "redContent",
    selectedFlowerWeekColumn,
    "FLOWERING / RIPENING STAGE"
  );
  requiredNutrient = {};
  volumeCalculator(selectedNutrientMediaVegArray, selectedVegWeekColumn);
  volumeCalculator(selectedNutrientMediaFlowerArray, selectedFlowerWeekColumn);
  volumeTableDrawer(cycleInput);
  rowRemoval();

  // ========================== for handling switching between units ==================

  function gallonLiterToggler(array, divisor) {
    for (let i = 0; i < array.length; i++) {
      for (let j = 0; j <= array[i].length; j++) {
        if (typeof array[i][j] === "number")
          array[i][j] = array[i][j] / divisor;
      }
    }
    return array;
  }

  // ========================== for handling reservoir counter ========================
  function handleReservoirValue(param) {
    // 1 gallon=3.785liter
    if (reservoir_size === 1 && param === -1) return;
    reservoir_size = reservoir_size + param;

    $("#reservoir_value").val(reservoir_size);
    requiredNutrient = {};
    volumeCalculator(selectedNutrientMediaVegArray, selectedVegWeekColumn);
    volumeCalculator(
      selectedNutrientMediaFlowerArray,
      selectedFlowerWeekColumn
    );
  }

  $("#increment-btn").on("click", function (event) {
    event.preventDefault();
    // $("#gallon").prop("checked", true);
    handleReservoirValue(+1);
    // waterValue === "gallon" ? reservoir_size * 0 : reservoir_size * 1;
    tableRedrawer();
  });

  $("#decrement-btn").on("click", function (event) {
    event.preventDefault();
    // $("#gallon").prop("checked", true);
    handleReservoirValue(-1);
    tableRedrawer();
  });

  $("#reservoir_value").on("input", function () {
    reservoir_size = +$(this).val();
    tableRedrawer();
  });

  // ======================== for getting filter inputs ============================
  $("input[name='nutrient']").click(function () {
    nutrientValue = $("input[name='nutrient']:checked").val();
    if (nutrientValue === "easy_series") {
      $("#hydroponic").prop("disabled", true);
    } else {
      $("#hydroponic").prop("disabled", false);
    }
    selectedNutrientMediaVegArray = vegTableHandler();
    selectedNutrientMediaFlowerArray = flowerTableHandler();

    tableRedrawer();
  });

  // ==================== redrawing table based on selected media ====================
  $("input[name='media']").click(function () {
    // $("#gallon").prop("checked", true);
    substance = $("input[name='media']:checked").val();
    if (substance === "hydroponic") {
      $("#easy_series").prop("disabled", true);
    } else {
      $("#easy_series").prop("disabled", false);
    }
    selectedNutrientMediaVegArray = vegTableHandler();
    selectedNutrientMediaFlowerArray = flowerTableHandler();
    tableRedrawer();
  });

  $("input[name='nutrient']").click(function () {
    // $("#gallon").prop("checked", true);
    nutrientValue = $("input[name='nutrient']:checked").val();
    selectedNutrientMediaVegArray = vegTableHandler();
    selectedNutrientMediaFlowerArray = flowerTableHandler();
    tableRedrawer();
  });

  function deepCopyArray(array) {
    return array.map((row) => [...row]);
  }

  // ===================== redrawing table based on unit selected ======================
  $("input[name='water-unit']").click(function () {
    waterValue = $("input[name='water-unit']:checked").val();

    if (waterValue === "liter") {
      unitConvertedVegArray = deepCopyArray(selectedNutrientMediaVegArray);
      gallonLiterToggler(unitConvertedVegArray, 1);
      unitConvertedFlowerArray = deepCopyArray(
        selectedNutrientMediaFlowerArray
      );
      gallonLiterToggler(unitConvertedFlowerArray, 1);
      $("table").remove();
      createTable(
        unitConvertedVegArray,
        "greenContent",
        selectedVegWeekColumn,
        "VEGETATIVE STAGE"
      );
      createTable(
        unitConvertedFlowerArray,
        "redContent",
        selectedFlowerWeekColumn,
        "FLOWERING / RIPENING STAGE"
      );
      // }
      requiredNutrient = {};
      volumeCalculator(unitConvertedVegArray, selectedVegWeekColumn);
      volumeCalculator(unitConvertedFlowerArray, selectedFlowerWeekColumn);
      volumeTableDrawer(cycleInput);
      rowRemoval();
      closeBtnEl = $(".close-btn");
      closeBtnEl.prepend(svgIcon);
    }
    // if (waterValue === "gallon") {
    tableRedrawer();
    // }
  });

  // ===================== redrawing table based on selected weeks =======================
  $("select[name='veg_weeks']").change(function () {
    selectedVegWeekColumn = $("#veg_weeks").val();
    $("#gallon").prop("checked", true);
    tableRedrawer();
  });

  $("select[name='flower_weeks']").change(function () {
    selectedFlowerWeekColumn = $("#flower_weeks").val();
    $("#gallon").prop("checked", true);
    tableRedrawer();
  });

  // =================== setting table's top left column title header ==================
  function setTableHeader() {
    if (nutrientValue === "easy_series") {
      if (substance === "soil") return "Easy Series - Soil";
      else if (substance === "coco") return "Easy Series - Coco";
    } else if (nutrientValue === "holland_secret") {
      if (substance === "soil") return "Holland Secret - Soil";
      else if (substance === "coco") return "Holland Secret - Coco";
      else return "Holland Secret - Hydroponic";
    } else {
      if (substance === "soil") return "Dosaline Series - Soil";
      else if (substance === "coco") return "Dosaline Series - Coco";
      else return "Dosaline Series - Hydroponic";
    }
    rowRemoval();
  }

  // ================================ printing the tables ================================
  function printTheTable(tableContainer, header) {
    const tableToPrint = $(`#${tableContainer}`);
    const printWindow = window.open("", "", "width=1000,height=1000");
    $(".close-btn-icon").hide();
    printWindow.document.open();
    printWindow.document.write(
      "<style>table {border-collapse: collapse;} td, th {border: 1px solid #000; padding: 5px;}</style>"
    );

    printWindow.document.write(
      `<html><head><title>${header}</title></head><body>`
    );
    printWindow.document.write(`<h2>${header}</h2>`);
    printWindow.document.write(tableToPrint[0].outerHTML);
    printWindow.document.write("</body></html>");
    $(".close-btn-icon").show();
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  }
  $("#print_veg").on("click", () =>
    printTheTable("greenContent", "VEGETATIVE STAGE")
  );
  $("#print_flower").on("click", () =>
    printTheTable("redContent", "FLOWERING / RIPENING STAGE")
  );

  // ================================ downloading the tables ================================
  function downloadTheTable(tableContainer, header) {
    const table = $(`#${tableContainer}`)[0];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(table);
    XLSX.utils.book_append_sheet(wb, ws, header);
    const blob = new Blob(
      [new Uint8Array(XLSX.write(wb, { bookType: "xlsx", type: "array" }))],
      { type: "application/octet-stream" }
    );
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = `${header}.xlsx`;
    downloadLink.click();
  }

  $("#download_veg").on("click", () =>
    downloadTheTable("greenContent", "VEGETATIVE STAGE")
  );
  $("#download_flower").on("click", () =>
    downloadTheTable("redContent", "FLOWERING RIPENING STAGE")
  );

  //  =================================== Volume calculator ==============================

  function volumeCalculator(selectedArray, selectedWeek) {
    for (let i = 0; i < selectedArray.length - 1; i++) {
      let totalNutrient = 0;
      //adding nutrients
      for (let j = 0; j <= selectedWeek; j++) {
        typeof selectedArray[i][j] === "number" &&
          (totalNutrient += selectedArray[i][j]);
      }

      requiredNutrient.hasOwnProperty(selectedArray[i][0])
        ? (requiredNutrient[selectedArray[i][0]] += totalNutrient)
        : (requiredNutrient[selectedArray[i][0]] = totalNutrient);
      totalNutrient = totalNutrient * reservoir_size;
      totalNutrient.toFixed(2);
    }
  }
  volumeCalculator(selectedNutrientMediaVegArray, selectedVegWeekColumn);
  volumeCalculator(selectedNutrientMediaFlowerArray, selectedFlowerWeekColumn);

  function volumeTableDrawer(cycleInput) {
    let table = $("<table></table>");
    // creating table header
    theader = $("<tr></tr>");
    theader.append("<th collsapn=2>Volume Calculator</th>");
    theader.append(
      `<th colspan='4'><div class='user_table_input'><span>Batches Per Week</span></div></th>`
    );
    table.append(theader);
    thHeader = $("<tr></tr>");
    thHeader.append($("<th></th>"));
    thHeader.append(
      $("<th></th>").text(
        `${nutrientValue === "holland_secret" ? "ML" : "GRAM"}`
      )
    );
    thHeader.append(
      $("<th></th>").text(
        `${nutrientValue === "holland_secret" ? "LITRE" : "KILOGRAM"}`
      )
    );
    nutrientValue === "holland_secret" &&
      thHeader.append($("<th></th>").text("GALLONS"));
    table.append(thHeader);
    for (let key in requiredNutrient) {
      let newRow =
        key === "MICRO" || key === "GROW" || key === "BLOOM" || key === "BASE"
          ? $("<tr>")
          : $("<tr>").addClass("row_remove");
      let nutrientCell;

      if (
        key === "MICRO" ||
        key === "GROW" ||
        key === "BLOOM" ||
        key === "BASE"
      ) {
        nutrientCell = $("<td>").addClass("left-header").text(key);
      } else {
        nutrientCell = $("<td>").addClass("close-btn left-header").text(key);
      }
      let valueCell = $("<td>").text(
        (requiredNutrient[key] * reservoir_size * cycleInput).toFixed(2)
      );
      let totalQuantity = $("<td>").text(
        ((requiredNutrient[key] * reservoir_size * cycleInput) / 1000).toFixed(
          2
        )
      );
      let gallonsColumn = $("<td>").text(
        (
          (requiredNutrient[key] * reservoir_size * cycleInput * 0.264172) /
          1000
        ).toFixed(2)
      );
      nutrientValue === "holland_secret"
        ? newRow.append(nutrientCell, valueCell, totalQuantity, gallonsColumn)
        : newRow.append(nutrientCell, valueCell, totalQuantity);
      table.append(newRow);
      volumeTableContainer.append(table);
    }
  }
  rowRemoval();
  closeBtnEl = $(".close-btn");
  closeBtnEl.prepend(svgIcon);

  // ===================== removing the row and updating the table ===================
  function rowRemoval() {
    $(".row_remove").on("click", function (e) {
      $(this).remove();
      volumeCalculator(selectedNutrientMediaVegArray, selectedVegWeekColumn);
      volumeCalculator(
        selectedNutrientMediaFlowerArray,
        selectedFlowerWeekColumn
      );
    });
  }
  function handleQuantity(param) {
    $("#gallon").prop("checked", true);
    if (cycleInput === 1 && param === -1) return;
    cycleInput += param;
    $("#cycle-input").val(cycleInput);
    $("table").remove();
    createTable(
      selectedNutrientMediaVegArray,
      "greenContent",
      selectedVegWeekColumn,
      "VEGETATIVE STAGE"
    );
    createTable(
      selectedNutrientMediaFlowerArray,
      "redContent",
      selectedFlowerWeekColumn,
      "FLOWERING / RIPENING STAGE"
    );
    volumeTableDrawer(cycleInput);
    rowRemoval();
    closeBtnEl = $(".close-btn");
    closeBtnEl.prepend(svgIcon);
  }
  $("#cycle-increment").click(() => handleQuantity(1));
  $("#cycle-decrement").click(() => handleQuantity(-1));

  $("#desktop-link").on("click", function (event) {
    event.preventDefault();
    $('meta[name="viewport"]').remove();
    $(".mobile-view").hide(); // Hide mobile-specific elements
  });
});
